export default __webpack_public_path__ + "466ebfde5ddde2fb653246fc5d6165e5.svg";